import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=2070d828"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=2070d828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports